
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/editors",
      function () {
        return require("private-next-pages/info/editors.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/editors"])
      });
    }
  